import type { SVGProps } from "react";

export function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2 12l4.8-4.8a2 2 0 012.8 0L12 9.6l2.4-2.4a2 2 0 012.8 0L22 12" />
      <path d="M2 18l4.8-4.8a2 2 0 012.8 0L12 15.6l2.4-2.4a2 2 0 012.8 0L22 18" />
    </svg>
  );
}
